module.exports = __webpack_public_path__ + "media/fonts/SFProText-Bold-392b3ed7a463f6623a2d12f424de8fbd.eot";